import defaultImage from 'assets/images/default-user-image.png';
import noImage from 'assets/images/no-image-icon.png';

const imgSizesCalc = (aspect) => {
    let imgWidth = 0;
    let imgHeight = 0;
    let cropWidth = 0;
    let cropHeight = 0;
    let defaultImg = defaultImage;
    if (aspect === 4 / 5) {
        imgWidth = 120;
        imgHeight = 150;
        cropWidth = 200;
        cropHeight = 250;
        defaultImg = defaultImage;
    } else if (aspect === 16 / 9) {
        imgWidth = 200;
        imgHeight = 112.5;
        cropWidth = 320;
        cropHeight = 180;
        defaultImg = noImage;
    } else if (aspect === 1 / 1) {
        imgWidth = 150;
        imgHeight = 150;
        cropWidth = 150;
        cropHeight = 150;
        defaultImg = noImage;
    }

    return { imgWidth, imgHeight, cropWidth, cropHeight, defaultImg };
};

export default imgSizesCalc;
